<!--
 * @Description: 
 * @Date: 2020-11-10 16:47:38
 * @LastEditors: jml
 * @LastEditTime: 2020-12-03 20:57:25
-->
<template>
  <div class="sex">
    <svg width="240" height="130" viewport="0 0 240 130">
      <path
        d="M0 65 L30 130 L210 130 L240 65 L210 0 L30 0 Z"
        stroke="#868686"
        stroke-width="1"
        fill="none"
        stroke-dasharray="5 3"
      />
      <path
        :d="item.d"
        stroke-width="0"
        :fill="item.color"
        v-for="(item, index) in chartDataArr"
        :key="index"
        :style="{ transform: item.transform }"
      />
    </svg>
    <div class="icon-box">
      <div
        class="item"
        v-for="(item, index) in sexIconArr"
        :key="index"
        :style="{ width: `${item.d * 100}%` }"
      >
        <template v-if="item.d > 0.4">
          <img :src="item.icon" alt />
          <div>{{ `${item.b}` }}</div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
const manIcon =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAACzCAMAAAAZk3qSAAAAt1BMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8QiqlJAAAAPHRSTlMAvn+lQO7l2tFvabKfhWFZ+fRJMxoU3tfDwIpMOA7huq2pmpJ1VC0eCbV6UEUqJyMY6czIA8WVjQc7MI8ls7apAAAD8ElEQVRo3u3b13LiQBAF0EFCApFENjY5GDBgcrJ3/v+7do1dviUkGrd6HrZq9775waeEkCb0NOpuas3CzPMXeyVMNZPVnynmfBFkuVoj20xsKVnXV+nGlXQ4bizpVUelHkdydWT6fCqrb8TiSk19K+5aelGIJb3nyCOPsjSRNotqUFSZRaUoasSiHIrKsagiRb2wKJeinlhUmqIKLMqmqDGLKhMSBgfx0zBQxh73JpNau7ekrOLGEl8U0o+WZipGHqnBSv4Zn5kErFIQeoDEzrsdePdqSpJxxt52ik7qcPQn6n++0557v3qHdN0p6jspbVLphp3PlKOhZk7z4+RbIajV0DFjX0mejp9S4MIWWpQqpIqWpTH9pnZamCEWndJ0zl/Uk1TC4PMgp3JYlkmT+qSetYHUMO5Kk8TUIk3mQh1MUHksgMw8pHUpg6dhI2Ww9SlJGaxPtYkk/j2qeJfGvyZpqsSgWjTlMKgKTbkMakxTHQa1pKkUg1rR1AODqtJUmkHVaGrHoNo01WBQU5pKMKg9TXUZlCqSVJZDlUiqx6EckrI5lEtSOQ7VIakBh0qR1JFDpUnqF4faktQTh9qRVJ5DNUjK4lAJkhpxqBeS8jhUlqQyHKpPUgUOZZujciTlc6gBSc051JCkmhzqRFILDpUnqSSHskiqxaFmJFXhUCOSGnMoj6SWHCpDUhMOVSCpKofySarGoZ5Jqs2h5iQ15VBlktpzqGSISgVWtQxqopHBdZneZlDB9Ufmujhg8ags/l5cFVIeFI96D5XWlnhteBTeQtTpL1eaXato6vFPoimVvHxnp8BZbqVSVeoG9Yb7eU2p8+RtXIODRFMtjHIhCqEpjIcjc5RniBqbo14xYEqppTlqhbFXSk0MUBjwfUPU2hxVw4wgpdpKzaUU5o6mIeqsVFlKYRpaSCnUtJJ/HfVRHnuTUiiPtcxRFTPURik1llIo2r1KKRTtllIKx/srKYWV0kRKYVFSlVKo/63NUTUz1FYp1ZZSqEpOpRSqkmcphc6mvZhC25xBqiilcERTklJoQXGMUD1zVB8HYwIKOwVXSuG8rmOOqkspbPVSRqgjdmdSaogDVyl1MkKhYW4rpXCkvDNHNaQU9uaPUgp9YAkphUbMrjnqxQjloTohoFAj6Zmj+lIKPZ22OSpnhPINUwMphSafo5BCOV8NpRS6Ok9SCn3VT1IKZby8ESoZn3LDdZRw+cO+74TfXCeyM877ETWLaqaZlsKf+n7mkc3eh4jWLTqhwXezUpcUYjWTtyJvSjewg/ppLCeqQRtzfZrxa4DV1yvXC9xdv64/0hlNFScTf9jz3lUw7XI+kS+3VXR+A2H6zvr9jdbyAAAAAElFTkSuQmCC';
const womenIcon =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFIAAACzCAMAAAAt6ruOAAAAsVBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+3mHKcAAAAOnRSTlMAf78jLhcRa+BPPim7HQzx1quRb1s60Me0n4xYNgeaMvbasKR7YEP67OeVh4N4ZEXkzVRKBOnEpnPBet9w6QAABGtJREFUaN7s2Md24kAQBdBHlkAgTA4m2ZhkYAg2Hr///7BZzGJUbXVQw3LuFs4BqatfVTfcrDrt5TEs4FGurZh/5SslPEA4YMIpV8K9hlQEY9wn4E8H3OPMNCv4GzFdEb7G1IjgqdGjTgV+ctQKyvByo14IH2UajODjFw1u8NGhwQI+2jTYwMeSBmv4ONLgBB8hDc7wUaTBk2+w6b35pq9eDY+u9S942lFjXoSnesB0OUj378k87nBgGkj3L9EUd5pFFOY53K8SJKtnhkcoh63bIl6fei/tIv7zUgj3+V4QU5hvm/1hpdtAdvX2Nw0+p7+QTW0X06b/BneTfUwXUQhHhTNdvcNJlRkM4KDGTHawqm2p4R3HEbMaw6zCzM4TmJQCZpezNAYPiwb0Ppr0UTF2RC9948jip6h/7oB+fkPnSk8D6IzoaV2HRo++dNH5TG+vTkeIXI4GJ/nx5wSp8nIYH9AkLDmcKQtMqtY3NNlD7LSWQwjhQqNIfr+JNC8yrN9ptClMmNTFT42YCTVrFl/ku9/bLjK2KMQ0G+Fii46hTNUxLfIAkwqWs1gdLVrMa3hiQhuqFRN6wI02HVTN0TGSMV1c06YFiOgoGyOjjDenLN/Jfy0VlTe/o9W6iJkpOpay5HCm3RHYiMIzRMYEMzqYKhdecogtiRByHDrOykzW0l+NXF1b5TPQ1EWHLFrnllEBKtreG8uJsUsnQyVkl7puW7VcZMknzWsu4qZKLbzSTRdyT5REZIjgW9BNW6mVY3q3fc5wAPgC8JQaHXsZQu5T5kKJ7nnq7flB/LBNFWik9d66WlsBXR2UtZ2mdNu8SGOrFwBhyh1kpMT9ks5OH8DHRi4ugInalAa0kenT+tF7L8qDTLYZDygrpWCAV6VWr5nn36bae2NlR+1pJ6fAd2Uxquq1ZMQsrpDBFSndtiNmI/dDfp//NEREfJZFmTmJ1GY4Fvtp6nGsiBsAZuJvF9Qd+s1sQqXBDpPBtvjTrr3sJAwGUQAe7QUDFClQQVCoVW4hUYMYybz/gxnY0KH/1PS0MZC/33IWZ0XodE53ROTHrNJrmn36Z+WcPTS3rNNrmpZYOlZyN+5xQbEvt9M+USI7giEXtZW75OL0bxl/ndYO4Kzzk1623PXxAdqkgwn8gj9Od2qdTRjOffH4LcSjo2jTnk4qetkdUJ6AAVPKM2fAA1zx6ALK0QVvBjqHIY9YT4hWp6+McfI6Pcw7erNF2rkGg+5IEzKqRYpPRjXUEhcWqh07bE1mCeNcMloxrk8mMy4hIZM9l7AikxGXMSODe1bAF+aISxlpN1ZcrLYyuIgyllzOm9aY4draJ064pXquxjX/IXKe3EqcdnMkr6xnegH9RUYqIwGI3F1F5LOtkR1bI/068pIjvTqyssjA1kinjrzkyFYdWVmka2vkzNbIJ1sjI1sjm3ZEvmQ6A5/lqLCEM+3vUI4K23CKTwdjOSrM64pmPTsCLL5PDZthBHF6fDCcKCOI97EfuMpI9Qsfgqevh71TewAAAABJRU5ErkJggg==';
export default {
  data() {
    return {
      sexIconArr: []
    };
  },
  props: {
    chartData: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    chartDataArr() {
      const arr = [...this.chartData];
      const total = arr.reduce((pre, cur) => {
        pre += cur.value || 0;
        return pre;
      }, 0);
      const d = (arr[0] || {})['value'] / total;
      const x = Math.min(Math.max(200 * d, 25), 175);
      this.sexIconArr = [
        {
          d: d,
          b: ((arr[0] || {})['name'] || '').slice(3),
          w: x,
          icon: womenIcon
        },
        {
          d: 1 - d,
          b: ((arr[1] || {})['name'] || '').slice(3),
          w: x,
          icon: manIcon
        }
      ];
      (arr[0] || {})['value'] > 0 &&
        ((arr[0] || {})['d'] = `M15 65 L40 120 L${x + 15} 120 L${x +
          15} 10 L40 10 Z`);

      (arr[1] || {})['value'] > 0 &&
        ((arr[1] || {})['d'] = `M225 65 L200 120 L${x + 25} 120 L${x +
          25} 10 L200 10 Z`);
      arr.unshift({
        d:
          x > 100
            ? `M15 65 L40 120 L${x + 15} 120 L${x + 15} 10 L40 10 Z`
            : `M225 65 L200 120 L${x + 25} 120 L${x + 25} 10 L200 10 Z`,
        color: x > 100 ? '#FFE28A' : '#C2C1FF',
        transform: 'translate(5px, 4px)'
      });
      return arr;
    }
  },
  created() {}
};
</script>

<style lang="scss" scoped>
.sex {
  position: relative;
  .icon-box {
    position: absolute;
    left: 40px;
    top: 10px;
    width: 160px;
    height: 110px;
    display: flex;
    .item {
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: #ffffff;
      line-height: 1;
      img {
        height: 50%;
        margin-bottom: 15px;
      }
    }
  }
}
</style>
